function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { path } from 'ramda';
import { stateGo } from 'redux-ui-router';
import { i18n, MetadataActions, MetadataConstants, MetadataSelectors, SessionSelectors } from 'invision-core';
import CustomerCareLocaleKeys from '../../../../locales/keys';
import { CurrentCustomerIdSelector } from '../../../../reducers/selectors/customer.selectors';
import { EwalletErrorSelector, IsRetrievingEwalletDataSelector, PaymentInstrumentsCanBeUsedForOrderingWithTypeNamesViewModelSelector, SelectedPaymentMethodSelector, UserHasEWalletAdminAccess } from '../../../../reducers/selectors/customer.ewallet.selectors';
import { CurrentMemberHasCreatePaymentInstrumentPermissionsSelector } from '../../../../reducers/selectors/customer.household.selectors';
import { CurrentSubscriptionIdSelector, CurrentSubscriptionSelector, IsFetchingDataSelector, UserCanIssueCreditToAlternatePaymentInstrument } from '../../../../reducers/selectors/customer.subscriptions.selectors';
import { retrieveWallet, selectPaymentMethod } from '../../../../reducers/actions/customer.ewallet.actions';
import * as RemoveOfferingSelectors from '../../../../reducers/selectors/offering.remove.selectors';
import { calculateChangeOfServiceQuote, retrieveOfferingRemovalContext, submitChangeOfServiceOrderRemoval } from '../../../../reducers/actions/offering.remove.actions';
import * as SubscriptionConstants from '../../../shared/constants/subscriptions.constants';
import { NOTIFICATION_TIME_LENGTH, DBSS_DECIMAL_PRECISION } from '../../../../customercare.constants';
import { DASHBOARD_ROUTE } from '../../../../reducers/constants/dashboard.constants';
var RemoveOfferController = /*#__PURE__*/function () {
  function RemoveOfferController($ngRedux, $q, $filter, uiNotificationService) {
    var _this = this;
    _classCallCheck(this, RemoveOfferController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $q: $q,
      $filter: $filter,
      uiNotificationService: uiNotificationService,
      CustomerCareLocaleKeys: CustomerCareLocaleKeys,
      DBSS_DECIMAL_PRECISION: DBSS_DECIMAL_PRECISION
    });
    this.confirmationPopup = {
      onRegisterApi: function onRegisterApi(_ref) {
        var api = _ref.api;
        _this.confirmationPopup.api = api;
      }
    };
    this.removal = {
      changeImmediately: true,
      creditAmount: 0,
      creditAmountType: 'max',
      creditReason: null,
      customAmount: 0,
      sendNotification: true,
      terminationReason: null
    };
    this.onConfirmation = this.onConfirmation.bind(this);
  }
  return _createClass(RemoveOfferController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this2 = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          canIssueCreditToAlternatePaymentMethod: UserCanIssueCreditToAlternatePaymentInstrument(store),
          creditReasons: MetadataSelectors.codes.MetadataOptionsForCodeValuesSelector(MetadataConstants.codes.CreditReasons, store),
          creditReasonsLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.CreditReasons, store),
          currency: RemoveOfferingSelectors.CurrencySelector(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          currentMemberCanCreatePaymentInstrument: CurrentMemberHasCreatePaymentInstrumentPermissionsSelector(store),
          currentRemainingAmount: RemoveOfferingSelectors.QuoteOfferRemainingAmountSelector(store),
          currentRemoval: RemoveOfferingSelectors.QuoteOfferSelector(store),
          currentSubscription: CurrentSubscriptionSelector(store),
          eWalletError: EwalletErrorSelector(store),
          isCalculatingQuoteSelector: RemoveOfferingSelectors.IsCalculatingQuoteSelector(store),
          isFetchingData: IsFetchingDataSelector(store),
          isFetchingEwalletData: IsRetrievingEwalletDataSelector(store),
          isSubmittingOrder: RemoveOfferingSelectors.IsSubmittingOrderSelector(store),
          language: SessionSelectors.LanguageSelector(store),
          lastRoute: SessionSelectors.LastRouteSelector(store),
          lastAttemptedError: RemoveOfferingSelectors.LastAttemptErrorSelector(store),
          subscriptionId: CurrentSubscriptionIdSelector(store),
          offeringId: RemoveOfferingSelectors.FirstOfferingIdSelector(store),
          offeringName: RemoveOfferingSelectors.OfferingNameSelector(store),
          paymentInstruments: PaymentInstrumentsCanBeUsedForOrderingWithTypeNamesViewModelSelector(store),
          removeItemHasContractEnd: RemoveOfferingSelectors.RemoveItemsHasContractEndSelector(store),
          removeItems: RemoveOfferingSelectors.RemoveItemsSelector(store),
          removeItemsAndAmounts: RemoveOfferingSelectors.RemoveItemsRemainingAmountSelector(store),
          removeItemsPaymentInstrument: RemoveOfferingSelectors.RemoveItemsPaymentInstrumentSelector(store),
          removeOfferItemsIds: RemoveOfferingSelectors.RemoveOfferItemsRequestSelector(store),
          subscriptionTerminationReasons: MetadataSelectors.codes.MetadataOptionsForCodeValuesSelector(MetadataConstants.codes.SubscriptionTerminationReason, store),
          subscriptionTerminationLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.SubscriptionTerminationReason, store),
          selectedPaymentMethod: SelectedPaymentMethodSelector(store),
          totalItemsRemainingAmount: RemoveOfferingSelectors.RemoveItemsTotalAmountSelector(store),
          userHasEWalletAdminAccess: UserHasEWalletAdminAccess(store),
          waiveFeeReasons: MetadataSelectors.codes.MetadataOptionsForCodeValuesSelector(MetadataConstants.codes.WaiveFeeReason, store),
          waiveFeeReasonsLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.WaiveFeeReason, store)
        };
      };
      var controllerActions = {
        calculateChangeOfServiceQuote: calculateChangeOfServiceQuote,
        fetchCodeType: MetadataActions.codes.fetchCodeTypes,
        retrieveOfferingRemovalContext: retrieveOfferingRemovalContext,
        retrieveWallet: retrieveWallet,
        selectPaymentMethod: selectPaymentMethod,
        stateGo: stateGo,
        submitChangeOfServiceOrderRemoval: submitChangeOfServiceOrderRemoval
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this2.state = state;
        _this2.actions = actions;
      });
      if (!this.state.subscriptionTerminationLoaded) {
        this.actions.fetchCodeType(MetadataConstants.codes.SubscriptionTerminationReason);
      }
      if (!this.state.creditReasonsLoaded) {
        this.actions.fetchCodeType(MetadataConstants.codes.CreditReasons);
      }
      if (!this.state.waiveFeeReasonsLoaded) {
        this.actions.fetchCodeType(MetadataConstants.codes.WaiveFeeReason);
      }
      this.$q.all([this.actions.retrieveOfferingRemovalContext(this.state.removeOfferItemsIds, this.state.currentCustomerId), this.actions.retrieveWallet({
        customerId: this.state.currentCustomerId
      })]).then(function () {
        return _this2.actions.selectPaymentMethod(_this2.state.removeItemsPaymentInstrument);
      }).then(function () {
        return _this2.actions.calculateChangeOfServiceQuote(_this2.createRequest(), _this2.state.currentCustomerId);
      }).then(function () {
        _this2.removal.creditAmount = _this2.state.currentRemainingAmount;
      }).catch(function () {
        var message = path(['eWalletError', 'message'], _this2.state) || path(['subscriptionError', 'message'], _this2.state) || path(['lastAttemptedError', 'message'], _this2.state);
        if (message) {
          _this2.uiNotificationService.transientError(message);
        }
      });
    }
  }, {
    key: "handleSetEffectiveType",
    value: function handleSetEffectiveType() {
      this.calculateChangeOfService();
      this.removal.creditAmount = 0;
      this.removal.creditAmountType = 'max';
      this.removal.creditReason = null;
      this.removal.customAmount = 0;
    }
  }, {
    key: "isCurrentPaymentMethodRemoved",
    value: function isCurrentPaymentMethodRemoved() {
      if (!this.state.selectedPaymentMethod) {
        return false;
      }
      return this.state.selectedPaymentMethod.Status === SubscriptionConstants.PAYMENT_METHOD_STATUSES.REMOVED;
    }
  }, {
    key: "calculateChangeOfService",
    value: function calculateChangeOfService() {
      var _this3 = this;
      this.actions.calculateChangeOfServiceQuote(this.createRequest(), this.state.currentCustomerId).then(function () {
        _this3.removal.creditAmount = _this3.removal.creditAmountType === 'max' ? _this3.state.currentRemainingAmount : _this3.removal.creditAmount;
      });
    }
  }, {
    key: "confirmRemoval",
    value: function confirmRemoval() {
      if (this.removeOfferForm.$valid && (!this.removal.changeImmediately || this.isAmountValid)) {
        this.removeOfferForm.$setPristine();
        this.removeOfferForm.$setUntouched();
        this.confirmationPopup.api.open();
      }
    }
  }, {
    key: "onConfirmation",
    value: function onConfirmation(confirmed) {
      if (confirmed) {
        this.removeOffer();
      }
      this.confirmationPopup.api.close();
    }
  }, {
    key: "createRequest",
    value: function createRequest() {
      var removeOfferRequest = {
        ChangeImmediately: this.removal.changeImmediately,
        CreditAmount: this.removal.creditAmount,
        CreditPaymentInstrument: this.state.selectedPaymentMethod,
        CreditPaymentInstrumentId: this.state.selectedPaymentMethod ? this.state.selectedPaymentMethod.Id : null,
        CreditReason: this.removal.creditReason,
        OfferingId: this.state.offeringId,
        RemoveItems: this.state.removeItems,
        RemoveReasonCode: this.removal.terminationReason,
        SendNotification: this.removal.sendNotification
      };
      return removeOfferRequest;
    }
  }, {
    key: "removeOffer",
    value: function removeOffer() {
      var _this4 = this;
      this.actions.submitChangeOfServiceOrderRemoval(this.createRequest(), this.state.currentCustomerId).then(function () {
        _this4.uiNotificationService.success(i18n.translate(_this4.CustomerCareLocaleKeys.REMOVE_OFFER.REMOVE_SUCCESSFUL), null, {
          timeOut: NOTIFICATION_TIME_LENGTH
        });
        _this4.actions.stateGo(DASHBOARD_ROUTE);
      }).catch(function (error) {
        _this4.uiNotificationService.error(error.translatedMessage, null, {
          timeOut: NOTIFICATION_TIME_LENGTH
        });
      });
    }
  }, {
    key: "isAmountValid",
    get: function get() {
      var value = parseFloat(this.removal.creditAmount);
      return value > 0 && value <= this.state.currentRemainingAmount;
    }
  }, {
    key: "handleSetCreditAmount",
    value: function handleSetCreditAmount() {
      if (this.removal.creditAmountType === 'max') {
        this.removal.customAmount = undefined;
        this.removal.creditAmount = this.state.currentRemainingAmount;
        this.removeOfferForm.creditCustomAmount.$setUntouched();
      } else if (this.removal.creditAmountType === 'custom') {
        this.removal.creditAmount = this.removal.customAmount || 0;
      }
      this.calculateChangeOfService();
    }
  }, {
    key: "updateCustomAmount",
    value: function updateCustomAmount() {
      this.removal.creditAmount = this.removal.customAmount;
    }
  }, {
    key: "canCreatePaymentInstruments",
    get: function get() {
      return this.state.currentMemberCanCreatePaymentInstrument && this.state.userHasEWalletAdminAccess;
    }
  }, {
    key: "isLoading",
    get: function get() {
      return this.state.isFetchingData || this.state.isFetchingEwalletData || this.state.isCalculatingQuote || this.state.isSubmittingOrder;
    }
  }, {
    key: "formattedRemainingAmount",
    get: function get() {
      return this.$filter('invCurrency')(this.state.currentRemoval.totalRemainingAmount, this.state.currency);
    }
  }]);
}();
export default {
  template: require('./remove.offer.template.html'),
  controller: RemoveOfferController,
  controllerAs: 'removeOfferController'
};